import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { API, errText } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const Shell = ({ children }) => (
  <div className="sd-app flex items-center justify-center min-h-screen p-4">
    <div className="w-full max-w-md card-sticky p-8 fade-up">{children}</div>
  </div>
);

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await axios.post(`${API}/auth/forgot-password`, { email }); } catch (err) { /* generic anyway */ }
    setDone(true);
  };
  return (
    <Shell>
      <h2 className="font-heading font-bold text-2xl mb-4">Forgot password</h2>
      {done ? (
        <p data-testid="forgot-confirmation" className="text-sm">If that email is registered, a reset link has been sent. Check your inbox.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div><label className="sd-label">Email</label>
            <input data-testid="forgot-email-input" className="sd-input mt-1" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></div>
          <button data-testid="forgot-submit-button" className="btn-tactile w-full py-2.5">Send reset link</button>
        </form>
      )}
      <Link to="/login" className="block mt-4 text-xs font-semibold underline">← Back to sign in</Link>
    </Shell>
  );
}

export function ResetPassword() {
  const [sp] = useSearchParams();
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      const { data } = await axios.post(`${API}/auth/reset-password`, { token: sp.get("token") || "", password });
      setMsg(data.message);
      setTimeout(() => nav("/login"), 1500);
    } catch (error) { setErr(errText(error)); }
  };
  return (
    <Shell>
      <h2 className="font-heading font-bold text-2xl mb-4">Reset password</h2>
      {msg ? <p data-testid="reset-success" className="text-sm">{msg}</p> : (
        <form onSubmit={submit} className="space-y-4">
          <div><label className="sd-label">New password</label>
            <input data-testid="reset-password-input" className="sd-input mt-1" type="password" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} required /></div>
          {err && <div data-testid="reset-error" className="text-sm font-semibold text-red-700">{err}</div>}
          <button data-testid="reset-submit-button" className="btn-tactile w-full py-2.5">Update password</button>
        </form>
      )}
      <Link to="/login" className="block mt-4 text-xs font-semibold underline">← Back to sign in</Link>
    </Shell>
  );
}

export function SSOPage() {
  const [sp] = useSearchParams();
  const [err, setErr] = useState("");
  const { login } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    const token = sp.get("token");
    if (!token) { setErr("Missing SSO token"); return; }
    axios.post(`${API}/auth/sso`, { token })
      .then(({ data }) => {
        login(data.token, data.user);
        window.history.replaceState({}, "", "/");
        nav("/", { replace: true });
      })
      .catch((e) => setErr(errText(e)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Shell>
      <h2 className="font-heading font-bold text-2xl mb-2">Signing you in via SND CRM…</h2>
      {err && (
        <div>
          <p data-testid="sso-error" className="text-sm font-semibold text-red-700 mb-3">{err}</p>
          <Link to="/login" className="btn-tactile inline-block px-4 py-2 text-sm">Back to sign-in info</Link>
        </div>
      )}
    </Shell>
  );
}
